import image_1 from "../../assets/img/events/kailash-kher/1.jpeg";
import image_2 from "../../assets/img/events/kailash-kher/2.jpeg";
import image_3 from "../../assets/img/events/kailash-kher/3.jpeg";
import image_4 from "../../assets/img/events/kailash-kher/4.jpeg";
import image_5 from "../../assets/img/events/kailash-kher/5.jpeg";
import image_6 from "../../assets/img/events/kailash-kher/6.jpeg";
import image_7 from "../../assets/img/events/kailash-kher/7.jpeg";
import image_8 from "../../assets/img/events/kailash-kher/8.jpeg";
import image_9 from "../../assets/img/events/kailash-kher/9.jpeg";
import { Carousel } from "react-bootstrap";

const KailashKherEventComponent = () => {
  return (
    <>
      {/* <section className="bsb-hero-1 px-3 kk-event-banner">
        <div className="text-center w-100 btn-event-registration">
        </div>
      </section> */}
      <section
        className="p-5"
        style={{
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundImage:
            "url('https://img.freepik.com/free-vector/gray-abstract-wireframe-background_53876-99911.jpg?semt=ais_hybrid')",
        }}
      >
        <h2 className="text-center fw-bolder" style={{color:"rgba(236, 159, 5, 1)"}}>EVENT HIGHLIGHTS</h2>

        <div className="container border shadow">
          <Carousel
            interval={null}
            slide={true}
            indicators={true}
            controls={true}
          >
            <Carousel.Item>
              <div className="container">
                <div className="row py-3 d-flex align-items-end">
                  <div className="col-md-4 px-4 my-2">
                    <img
                      className="d-block rounded-3 kk-event-highlights"
                      src={image_3}
                      alt="First slide"
                      height="300px"
                      width="100%"
                    />
                  </div>
                  <div className="col-md-4 px-4 my-2">
                    <img
                      className="d-block rounded-3 kk-event-highlights"
                      src={image_6}
                      alt="First slide"
                      height="100%"
                      width="100%"
                    />
                  </div>
                  <div className="col-md-4 px-4 my-2">
                    <img
                      className="d-block rounded-3 kk-event-highlights"
                      src={image_1}
                      alt="First slide"
                      height="300px"
                      width="100%"
                    />
                  </div>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="container">
                <div className="row py-3 d-flex align-items-end">
                  <div className="col-md-4 px-4 my-2">
                    <img
                      className="d-block rounded-3 kk-event-highlights"
                      src={image_4}
                      alt="First slide"
                      height="300px"
                      width="100%"
                    />
                  </div>
                  <div className="col-md-4 px-4 my-2">
                    <img
                      className="d-block rounded-3 kk-event-highlights"
                      src={image_5}
                      alt="First slide"
                      height="300px"
                      width="100%"
                    />
                  </div>
                  <div className="col-md-4 px-4 my-2">
                    <img
                      className="d-block rounded-3 kk-event-highlights"
                      src={image_2}
                      alt="First slide"
                      height="300px"
                      width="100%"
                    />
                  </div>
                </div>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className="container">
                <div className="row py-3 d-flex align-items-end">
                  <div className="col-md-4 px-4 my-2">
                    <img
                      style={{ height: "300px" }}
                      className="d-block rounded-3 kk-event-highlights"
                      src={image_7}
                      alt="First slide"
                      height="300px"
                      width="100%"
                    />
                  </div>
                  <div className="col-md-4 px-4 my-2">
                    <img
                      style={{ height: "300px" }}
                      className="d-block rounded-3 kk-event-highlights"
                      src={image_8}
                      alt="First slide"
                      height="300px"
                      width="100%"
                    />
                  </div>
                  <div className="col-md-4 px-4 my-2">
                    <img
                      style={{ height: "300px" }}
                      className="d-block rounded-3 kk-event-highlights"
                      src={image_9}
                      alt="First slide"
                      height="300px"
                      width="100%"
                    />
                  </div>
                </div>
              </div>
            </Carousel.Item>
            {/* <Carousel.Item>
              <div className="container">
                <div className="row py-3 d-flex align-items-end">
                  <div className="col-md-4 px-4 my-2">
                    <video
                      className="rounded-5"
                      controls
                      muted
                      playsInline
                      loop
                      style={{ objectFit: "cover" }}
                    >
                      <source
                        type='video/mp4; codecs="avc1.4D401E, mp4a.40.2"'
                        src={MahasangamVideo}
                      ></source>
                    </video>
                  </div>
                  <div className="col-md-4 px-4 my-2">
                    <video
                      className="rounded-5"
                      controls
                      muted
                      playsInline
                      loop
                      style={{ objectFit: "cover" }}
                    >
                      <source
                        type='video/mp4; codecs="avc1.4D401E, mp4a.40.2"'
                        src={MahasangamVideo}
                      ></source>
                    </video>
                  </div>
                  <div className="col-md-4 px-4 my-2">
                    <video
                      className="rounded-5"
                      controls
                      muted
                      playsInline
                      loop
                      style={{ objectFit: "cover" }}
                    >
                      <source
                        type='video/mp4; codecs="avc1.4D401E, mp4a.40.2"'
                        src={MahasangamVideo}
                      ></source>
                    </video>
                  </div>
                </div>
              </div>
            </Carousel.Item> */}
          </Carousel>
        </div>

        <div className="container pt-5 events-details-section">
          <div className="row mb-3">
            <div className="custom-font-size-list-text">
              <p className="custom-font-size-list mx-0">
                The{" "}
                <span className="fw-bold">
                  Shiv Shakti Kendra Grand Finale,
                </span>{" "}
                held at Talkatora Stadium by IMPC, was a truly historic and
                spiritually uplifting event. It marked the powerful culmination
                of the Bhagva Trishool Yatra — a nation-wide initiative to
                awaken collective consciousness for temples, saints, and Sanatan
                Dharma.
              </p>
              <p className="custom-font-size-list mx-0">
                The evening came alive with soulful live performances by{" "}
                <span className="fw-bold">
                  Kailash Kher, Renuka Panwar, Manoj Tiwari, and Rishabh Pandey,{" "}
                </span>
                filling the atmosphere with devotion, energy, and pride. A key
                highlight was the{" "}
                <span className="fw-bold"> launch of the Bhagva App,</span> in
                the presence of esteemed dignitaries like{" "}
                <span className="fw-bold">
                  Kailash Kher, Manoj Tiwari, Sunita Duggal Ji, Sudhanshu Ji
                  Maharaj, and the Hon’ble Chief Minister of Delhi, Smt. Rekha
                  Gupta Ji.
                </span>
              </p>

              <h3>
                Bhagva App is a spiritual tech revolution that enables you to:
              </h3>
              <ul className="custom-font-size-list">
                <li>
                  Book{" "}
                  <span className="fw-bold">verified and skilled pandits</span>{" "}
                  for rituals.
                </li>
                <li>
                  Access the daily <span className="fw-bold">Panchang.</span>
                </li>
                <li>
                  Experience{" "}
                  <span className="fw-bold">
                    live and AR/VR temple darshan{" "}
                  </span>{" "}
                  — all at the tap of a button.
                </li>
              </ul>
            </div>

            <h5>
              More than an event, it was a declaration —{" "}
              <span className="fw-bold" style={{ color: "rgb(254, 94, 0)" }}>
                Sanatan is rising, and Bharat is awakening.
              </span>
            </h5>

            <h3 className="mt-3">
              Notable Dignitaries Present at the IMPC Event on 18th April:
            </h3>

            <ul className="custom-font-size-list">
              <li>
                <span className="fw-bold" >
                  Mahamandaleshwar Naval Kishor Ji Maharaj
                </span>
              </li>
              <li>
                <span className="fw-bold">Shri Kailash Kher,</span> Renowned
                Singer
              </li>
              <li>
                <span className="fw-bold">Shri Manoj Tiwari Ji,</span> Member of
                Parliament and Celebrated Actor
              </li>
              <li>
                <span className="fw-bold">Smt. Sunita Duggal Ji,</span> Former
                Member of Parliament
              </li>
              <li>
                <span className="fw-bold">Sudhanshu Ji Maharaj,</span> Revered
                Spiritual Leader
              </li>
              <li>
                <span className="fw-bold">Shri Mahipal Dhanda Ji,</span> Cabinet
                Minister, Haryana
              </li>
              <li>
                <span className="fw-bold">Smt. Rekha Gupta Ji,</span> Hon’ble
                Chief Minister of Delhi
              </li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default KailashKherEventComponent;
